/* global $ */

import 'bootstrap-daterangepicker';
import pad from '../helpers/pad';

const $dateRangePickerFrom = $('.js-daterangepicker-value-from');
const $dateRangePickerTo = $('.js-daterangepicker-value-to');
const today = new Date();
const DD = pad(String(today.getDate()), 2, '0');
const MM = pad(String(today.getMonth() + 1), 2, '0');
const YYYY = today.getFullYear();
let $daterangepickers = $('.js-daterangepicker');

const DATERANGEPICKER = {
  nl: {
    days: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    daysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  },
};

const daterangepickerObj = {
  /**
   * Setup things like languages and options and start initialising the daterangepickers
   * @return {void}
   */
  initialize() {
    $daterangepickers = $('.js-daterangepicker');

    if ($daterangepickers.length) {
      // Setup the language to use for the daterangepickers
      this.lang = DATERANGEPICKER.nl;

      // 'Symlink' daysMin to short because they're the same and I don't
      // want to waste precious bytes
      this.lang.daysMin = this.lang.daysShort;

      this.baseOptions = {
        locale: {
          format: 'DD-MM-YYYY',
          separator: ' t/m ',
          daysOfWeek: this.lang.daysShort,
          monthNames: this.lang.monthsShort,
        },
        startDate: $dateRangePickerFrom.val() !== '' ? $dateRangePickerFrom.val() : `${DD}-${MM}-${YYYY}`,
        endDate: $dateRangePickerTo.val() !== '' ? $dateRangePickerTo.val() : `${DD}-${MM}-${YYYY}`,
        autoUpdateInput: false,
        autoApply: true,
      };

      // Initialize all daterangepickers
      $daterangepickers.toArray().forEach(this.createDaterangepicker.bind(this));
    }
  },

  /**
   * Create a daterangepicker
   * @param {HTMLInputElement} daterangepicker
   * @return {void}
   */
  createDaterangepicker(daterangepicker) {
    const $daterangepicker = $(daterangepicker);

    // Clone the options to prevent mutating the options object in other places
    const options = { ...this.baseOptions };

    // And last but not least -- create the datepicker!
    $daterangepicker.daterangepicker(options, (startDate, endDate) => {
      $daterangepicker.val(`${startDate.format('DD-MM-YYYY')} - ${endDate.format('DD-MM-YYYY')}`);
    });
  },
};

export default daterangepickerObj;
